export default "__VITE_ASSET__C0lvqJKI__"